import db from '@/utils/localstorage'

export default {
  namespaced: true,
  state: {
    token: db.get('USER_TOKEN'),
    expireTime: db.get('EXPIRE_TIME'),
    user: db.get('USER'),
    permissions: db.get('PERMISSIONS'),
    roles: db.get('ROLES'),
    purchaseDictData: db.get('purchaseDictData'),
    dictData: db.get('dictData')
  },
  mutations: {
    setToken (state, val) {
      db.save('USER_TOKEN', val)
      state.token = val
    },
    setExpireTime (state, val) {
      db.save('EXPIRE_TIME', val)
      state.expireTime = val
    },
    setUser (state, val) {
      db.save('USER', val)
      state.user = val
    },
    setPermissions (state, val) {
      db.save('PERMISSIONS', val)
      state.permissions = val
    },
    setRoles (state, val) {
      db.save('ROLES', val)
      state.roles = val
    },
    setPurchaseDictData (state, val) {
      db.save('purchaseDictData', val)
      state.purchaseDictData = val
    },
    setDictData (state, val) {
      db.save('dictData', val)
      state.dictData = val
    },
    setRenewalDictData (state, val) {
      if (val.arr && val.obj) {
        if (val.arr[0] && val.arr[0].isRenewal) {
          state.dictData[val.arr[0].listVal] = val.arr
          state.dictData[val.arr[0].objVal] = val.obj
          db.save('dictData', state.dictData)
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/account.js